export default {
    info: 'ข้อมูล',
    confirm: 'ยืนยัน'
}
